/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIdCard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 3h20v18H2zm2 2v14h16V5zm5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm12 2h-4V9h4zM7.39 15.472c-.24.232-.39.588-.39 1.1V17H5v-.429c0-.91.278-1.84 1.002-2.538C6.724 13.337 7.755 13 9 13c1.245 0 2.276.337 2.998 1.033.724.699 1.002 1.629 1.002 2.538V17h-2v-.429c0-.511-.15-.867-.39-1.099C10.366 15.24 9.896 15 9 15s-1.367.238-1.61.472zM18 15h-4v-2h4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIdCard as IdCard };
